export default __webpack_public_path__ + "static/imageObjetivosDesarollo-43d9cddbf1234f92dd49b85ab4d65ecf.jpg";